import axios from "axios";
import env from "../config/envHelper";

const privateApiClient = axios.create({
  baseURL: env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

let _store = null;
export function injectStore(storeInstance) {
  _store = storeInstance;
}

privateApiClient.interceptors.request.use((config) => {
  const token = _store?.getState().auth.accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
  failedQueue.forEach((promise) => {
    if (error) promise.reject(error);
    else promise.resolve(token);
  });
  failedQueue = [];
}

privateApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401 || originalRequest._retry || originalRequest.url?.includes("/auth/refresh")) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return privateApiClient(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const { data } = await axios.post(`${env.REACT_APP_BACKEND_URL}/auth/refresh`, {}, { withCredentials: true });

      const { setCredentials } = await import("../store/authSlice");
      _store?.dispatch(setCredentials({ accessToken: data.accessToken, idToken: data.idToken }));
      processQueue(null, data.accessToken);

      originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
      return privateApiClient(originalRequest);
    } catch (refreshError) {
      const { clearCredentials } = await import("../store/authSlice");
      processQueue(refreshError, null);
      _store?.dispatch(clearCredentials());
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  },
);

export default privateApiClient;
